// Cache
const zeroCoord = { x: 0, y: 0 }

/**
 * Calculates the distance between two vec2's
 *
 * @param {object} p1 - the first point {x, y}
 * @param {object} p2 - the second point {x, y}
 * @returns {number} the distance
 */
export const distanceBetween = (p1, p2 = zeroCoord) =>
  Math.sqrt(Math.pow(p2.x - p1.x, 2) + Math.pow(p2.y - p1.y, 2))

/**
 * Normalize angle into degrees
 *
 * @param {number} angle - the input angle
 * @returns {number} the corrected angle
 */
export const normalizeDegrees = angle => {
  // Use modulo operator to ensure angle is within 0-360 range
  angle = angle % 360

  // If angle is negative, add 360 to bring it within 0-360 range
  if (angle < 0) {
    angle = angle + 360
  }

  return angle
}
